var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAdd = function SvgAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    "data-name": "Component 1 \\u2013 1",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 20,
    fill: "#4aac9c",
    "data-name": "Rectangle 29",
    rx: 1,
    transform: "translate(9)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 20,
    fill: "#4aac9c",
    "data-name": "Rectangle 30",
    rx: 1,
    transform: "rotate(-90 5.5 5.5)"
  })));
};
export default SvgAdd;